import { SVGProps } from "react";

const Chart = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path d="M5.75902 16L3.64313 8.63158H1V7.36842H4.5195L6.11447 12.8811L8.80618 0H9.73567L11.6679 8.86L13.0654 4.08905H13.91L15.0719 7.36842H16V8.63158H14.2321L13.5455 6.66232L12.0081 11.9109H11.1075L9.27102 3.48653L6.66738 16H5.75902Z" />
    </svg>
  );
};

export default Chart;
